var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-name"},[_c('p',{staticClass:"column-en"},[_vm._v("\n    "+_vm._s(_vm.enName)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"column-cn"},[_vm._v("\n    "+_vm._s(_vm.cnName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }